export const GITHUB_REPO = "https://github.com/suhang12332/Swift-Craft-Launcher";
export const RELEASES_URL = `${GITHUB_REPO}/releases`;
export const ISSUES_URL = `${GITHUB_REPO}/issues`;
export const WIKI_URL = `${GITHUB_REPO}/wiki`;
export const LICENSE_URL = `${GITHUB_REPO}/blob/main/LICENSE`;
export const DISCUSSIONS_URL = `${GITHUB_REPO}/discussions`;

export const QQ_GROUP_URL = "https://qm.qq.com/cgi-bin/qm/qr?k=1057517524";
export const DISCORD_URL = "https://discord.com/invite/gYESVa3CZd";
export const BILIBILI_URL = "https://space.bilibili.com/627351279";
